import Datatable from "../../Components/Datatable"
import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EXPRESS_BASE_URL } from "../../../../../Helpers/apiConfig";

const AcceptIcon = ({ accepted }) => (
    <FontAwesomeIcon
        icon={accepted ? "fas fa-check-circle" : "fas fa-times-circle"}
        style={{ color: accepted ? "green" : "#dc3545", fontSize: "18px" }}
    />
);

export const AdminPurchaseAcceptanceList = () => {
    const [data, setData] = useState([]);
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);

    const columns = React.useMemo(
        () => [
            {
                Header: "İsim",
                Footer: "İsim",
                accessor: 'name',
            },
            {
                Header: "E-posta",
                Footer: "E-posta",
                accessor: 'email',
            },
            {
                Header: "Tarih",
                Footer: "Tarih",
                accessor: 'tarihText',
            },
            {
                Header: "Ön Bilgilendirme Formu",
                Footer: "Ön Bilgilendirme Formu",
                accessor: (row) => <AcceptIcon accepted={!!row.onbilgilendirmeRaw} />,
                id: 'onbilgilendirme',
            },
            {
                Header: "Mesafeli Satış Sözleşmesi",
                Footer: "Mesafeli Satış Sözleşmesi",
                accessor: (row) => <AcceptIcon accepted={!!row.satissozlesmesiRaw} />,
                id: 'satissozlesmesi',
            },
            {
                Header: "Cayma Hakkı",
                Footer: "Cayma Hakkı",
                accessor: (row) => <AcceptIcon accepted={!!row.caymahakkiRaw} />,
                id: 'caymahakki',
            },
        ],
        [],
    )

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "false",
                    "Access-Control-Allow-Origin": "*",
                };
                const res = await axios({
                    method: 'get',
                    url: `${EXPRESS_BASE_URL}/getindividualpurchaseaccepteds`,
                    headers: headerss
                });

                const rows = Array.isArray(res.data) ? res.data : [];
                const mapped = rows.map((row) => {
                    const tarihDate = row.tarih ? new Date(row.tarih) : null;
                    return {
                        name: row.name,
                        email: row.email,
                        tarihText: tarihDate ? tarihDate.toLocaleString("tr-TR") : "-",
                        onbilgilendirmeRaw: row.onbilgilendirme,
                        satissozlesmesiRaw: row.satissozlesmesi,
                        caymahakkiRaw: row.caymahakki,
                    };
                });
                setData(mapped);
            } catch (err) {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>Satın Alma Kabulleri</h1>
            </div>
            <h4>{msg}</h4>
            {loading && <div>Veriler Yükleniyor!</div>}

            {!loading && (
                <div>
                    <Datatable data={data} columns={columns} tableBaslik="Satın Alma Kabulleri" />
                </div>
            )}
        </div>
    );
};
export default AdminPurchaseAcceptanceList;
